import { Permissions } from '../../../../models/enums/permissions';
import * as React from 'react';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import { DeliveryAddressesTable } from '../../../../shared/components/DeliveryAddressesTable';
import { ShipToAddressRead } from '../../../../shared/models/ship-to-address-read';
import { PageNames } from '../../../../utils/app-constants';
import { navigateToPage } from '../../../../utils/history';
import { hasPermission } from '../../../../containers/authorization-helpers/has-permission';

interface IProps {
    addresses: ShipToAddressRead[];
    dealerId: string;
}

export const DealerAddressesScene = (props : IProps) => {
    const [canCreateAddress, setCanCreateAddress] = React.useState(false);

    React.useEffect(() => {
        const createPerm = Permissions.SupportDealersEdit;

        if (hasPermission({ requiredPermissions: [createPerm] })) {
            setCanCreateAddress(true);
        }
    }, []);

    return props.addresses ?
        <PageContent pageName={PageNames.SUPPORT_DEALERS_DETAILS}>
            <PageBody>
                {
                    props.addresses.length > 0
                        ? <DeliveryAddressesTable
                            addresses={ props.addresses }
                            dealerId={ props.dealerId }
                        />
                        : <div className="empty-placeholder-div">
                            <h2>
                                <i className="la la-warning" /><br/>
                                No delivery addresses
                            </h2>
                        </div>
                }

                {canCreateAddress && (
                    <div className="col-md-12 text-right">
                        <button
                            className="btn new"
                            onClick={() => navigateToPage(`/support/dealers/${props.dealerId}/addresses/create`)}
                        >
                            Add
                        </button>
                    </div>
                )}
            </PageBody>
        </PageContent> : null;
    
};
